import type { RootState } from "../store"

export const runtimeSelector = (state: RootState) => state.runtime
